
import { useEffect, useRef, useState } from "react";
import {Header} from "./components/Header"
import { LeftSideBar } from "./components/LeftSideBar";
import { RightSideBar }  from "./components/RightSideBar"
import { Main } from "./components/Main";
import {Footer} from "./components/Footer"
import { PhoneBar } from "./components/phoneBar";
import { SpeedInsights } from "@vercel/speed-insights/react";
import './index.css'
import { ChatBot } from "./components/ChatBot";






function App() {
  const[chatBot,setChatBot]=useState(false);
  const[darkMode,setDarkMode] = useState(JSON.parse(localStorage.getItem("darkMode")) || true)
  const[active,setActive]=useState( 'profile')
  const[manualScroll, setManualScroll]=useState(false)
  const[popup,setPopup]=useState(false);
  const topLine=useRef()
  const buttomLine=useRef()
  const lineContainer=useRef()
  const[notification,setNotif]=useState(true)
  
  
  const profilepic = darkMode ? "assets/profile.jpg" : "assets/lightpict.png";

useEffect(()=>{
  if(popup){
    lineContainer.current.classList.remove('space-y-2')
    topLine.current.classList.add('toXLine1')
    buttomLine.current.classList.add('toXLine2')
    setTimeout(()=>{
      topLine.current.classList.remove('toXLine1')
      buttomLine.current.classList.remove('toXLine2')
    },1000)
    
  } else{
    
    topLine.current.classList.add('w-7')
    topLine.current.classList.add('fromXLine1')
    buttomLine.current.classList.add('fromXLine2')
    setTimeout(()=>{
      lineContainer.current.classList.add('space-y-2')
      topLine.current.classList.remove('w-7')
      topLine.current.classList.remove('fromXLine1')
      buttomLine.current.classList.remove('fromXLine2')
    },1000)

  }

},[popup])








  return (
    <div
      className={`  h-full  w-auto min-h-[750px] 
      ${darkMode ? "bg-[#181a1b] text-white " : "bg-white text-black"}`}
    >
      <div
        key={popup}
        ref={lineContainer}
        onClick={() => setPopup(!popup)}
        className={`md:hidden fixed top 0 z-20 right-10 flex flex-col h-20 justify-center items-end -space-y-px `}
      >
        <div
          ref={topLine}
          className={`h-[1.5px]  
              ${!darkMode ? "bg-[#181a1b] " : "bg-white"}
               ${popup ? " w-7 -rotate-45 " : " w-4 "}`}
        ></div>
        <div
          ref={buttomLine}
          className={`h-[1.5px] w-7  
              ${!darkMode ? "bg-[#181a1b] " : "bg-white"}
              ${popup ? "rotate-45 " : ""}`}
        ></div>
      </div>
      {popup && (
        <PhoneBar
          darkMode={darkMode}
          setDarkMode={setDarkMode}
          active={active}
          setActive={setActive}
          setManualScroll={setManualScroll}
          setPopup={setPopup}
        />
      )}
      <Header
        active={active}
        setActive={setActive}
        darkMode={darkMode}
        setDarkMode={setDarkMode}
        setManualScroll={setManualScroll}
      />
      <LeftSideBar
        active={active}
        setActive={setActive}
        darkMode={darkMode}
        setManualScroll={setManualScroll}
      />
      <RightSideBar />
      <Footer active={active} darkMode={darkMode} />
      <Main
        darkMode={darkMode}
        setDarkMode={setDarkMode}
        active={active}
        setActive={setActive}
        manualScroll={manualScroll}
        setManualScroll={setManualScroll}
      />
      <div
        className={`fixed  flex  z-50 bottom-0 right-0 w-32 h-60 justify-center items-center ${
          chatBot ? "" : ""
        }`}
      >
        <div className="relative">
          {notification && (
            <div
              style={{animation:"bounce 1s infinite"}}
             className=" chattext-lg absolute -top-2 right-0 border-2 text-white bg-red-500 w-6 h-6 rounded-full flex items-center justify-center">
              1
            </div>
          )}
          <button
            className={`  border-2 rounded-full  border-gray-600`}
            onClick={() => {
              setNotif(false);
              setChatBot(!chatBot);
            }}
          >
            <img className="rounded-full w-12 h-12" src={profilepic} alt="" />
          </button>
        </div>
        <div>
          {chatBot && (
            <div className=" fixed flex  flex-col items-center bottom-0 right-0 md:bottom-24 md:right-24 w-screen h-[100dvh] md:h-1/2 md:w-96 ">
              <ChatBot
                darkMode={darkMode}
                setChatBot={setChatBot}
                chatBot={chatBot}
              />
            </div>
          )}
          <SpeedInsights />
        </div>
      </div>
    </div>
  );
}

export default App;
